import cx from 'classnames';
import * as React from 'react';

import './styles/CircleSpinner.scss';

// TODO
// • Namspace to align with or combine with LoadingIndicator?

type Props = {
  className?: string;
} & DefaultProps;

type DefaultProps = {
  color: 'jungle' | 'shamrock' | 'brand';
  size: 'large' | 'medium' | 'small';
};

export default class CircleSpinner extends React.Component<Props> {
  static defaultProps: DefaultProps = {
    color: 'brand',
    size: 'medium',
  };

  render() {
    const { className, color, size } = this.props;

    return (
      <div
        className={cx(
          'CircleSpinner',
          color && `CircleSpinner--${color}`,
          size && `CircleSpinner--${size}`,
          className
        )}
      />
    );
  }
}
